import { DatePickerFormFieldComponent } from '@vivli/shared/components';
import { CitationsGridView } from './citations-grid.view';
import { CSSProperties } from 'react';
import { ButtonView } from '@vivli/shared/views';
import { DTIAMRCommonConst } from '@vivli/shared/infrastructure/constants';
import { useToastApiContext } from '@vivli/core/infrastructure/context';
import { useCitationsContext } from '@vivli/shared/features/citations/infrastructure/context';
import { EditCitationView } from './edit-citation.view';
import { Subject } from 'rxjs';
import { AddCitationView } from './add-citation.view';
import { useModalApiContext } from '@vivli/core/infrastructure/context';

const buttonStyle: CSSProperties = {
    width: '200px',
};

const inputStyle: CSSProperties = {
    width: '350px',
};

const buttonContainerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    justifyContent: 'end',
    alignItems: 'center',
    columnGap: '1em',
    width: '100%',
};

export const CitationsView = () => {
    const _modal = useModalApiContext();
    const _toastService = useToastApiContext();
    const { defaultCitation, isLoading, addCitation, permissions } = useCitationsContext();

    const handleAddFromDoi = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const modalId = _modal.custom(
            <AddCitationView
                onCancel={() => _modal.dismiss(modalId)}
                onSave={(citationDoi) => {
                    const subject = new Subject<void>();

                    addCitation(citationDoi, null).subscribe({
                        next: (citation) => {
                            _modal.dismiss(modalId);
                            subject.next();
                            return citation;
                        },
                        error: () => {
                            subject.error('Unable to add citation.');
                            _toastService.error('Unable to add citation.');
                        },
                    });

                    return subject;
                }}
            />
        );
    };

    const handleAddFromUrl = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const modalId = _modal.custom(
            <EditCitationView
                citation={null}
                defaultCitationObject={defaultCitation}
                onCancel={() => _modal.dismiss(modalId)}
                onSave={(citation) => {
                    const subject = new Subject<void>();

                    addCitation(null, citation).subscribe({
                        next: (citation) => {
                            _modal.dismiss(modalId);
                            subject.next();
                            return citation;
                        },
                        error: () => {
                            subject.error('Unable to edit citation.');
                            _toastService.error('Unable to edit citation.');
                        },
                        complete: () => {},
                    });

                    return subject;
                }}
            />
        );
    };

    return (
        <>
            <div style={buttonContainerStyle}>
                <div>
                    {permissions.canViewPublishedDate && (
                        <DatePickerFormFieldComponent
                            readonly={!permissions.canEditPublishedDate}
                            name="finalDate"
                            label="Published Date"
                            style={inputStyle}
                        />
                    )}
                </div>
                {permissions.canAddCitation && (
                    <>
                        <ButtonView
                            style={buttonStyle}
                            isLoading={isLoading}
                            onClick={handleAddFromDoi}
                            dataId={DTIAMRCommonConst.AddCitationButton('FromDOI')}
                        >
                            Add Citation From DOI
                        </ButtonView>
                        <ButtonView
                            style={buttonStyle}
                            isLoading={isLoading}
                            onClick={handleAddFromUrl}
                            dataId={DTIAMRCommonConst.AddCitationButton('Manually')}
                        >
                            Add Citation Manually
                        </ButtonView>
                    </>
                )}
            </div>
            <CitationsGridView readonly={!permissions.canModifyCitation} />
        </>
    );
};
